/* eslint-disable import/no-unused-modules */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

interface Types {
  BacPlan: {
    id: string;
    planName: string;
    takafulProvider: { companyName: string };
    sumAssuranceTypeValueTypeId?: number;
    sumAssuranceTypeValue?: number;
    sumAssuranceTypeValueType?: { id: number; value: string };
    sumAssuranceType?: { key: string };
  };
}
const initialState = {
  BacPlan: {
    id: "",
    planName: "",
    takafulProvider: { companyName: "" }
  }
};

const bacPlanSlice = createSlice({
  name: "bacPlan",
  initialState,
  reducers: {
    AddBacPlan: (state, action) => {
      state.BacPlan = action.payload;
    }
  }
});

export const { AddBacPlan } = bacPlanSlice.actions;
export default bacPlanSlice.reducer;

export const getBacPlan = (state: RootState): Types => state?.bacPlan;
